import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-white/80 backdrop-blur-sm'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2">
          <img 
            src="https://static.readdy.ai/image/c35406c68f4851f7123e42c3a05fcb72/7284a9e366c89bc3def167baae8f05df.png" 
            alt="SEOPower AI SEO Analysis Tool – Official Logo" 
            className="h-10 w-auto"
          />
          <span className="text-xl font-bold" style={{ color: '#4f3af6' }}>SEOPower.co</span>
        </Link>

        <div className="flex items-center gap-8">
          <Link
            to="/"
            className={`text-base font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isActive('/') ? 'text-[#4f3af6]' : 'text-gray-700 hover:text-[#4f3af6]'
            }`}
          >
            Home
          </Link>
          <Link
            to="/guide"
            className={`text-base font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isActive('/guide') ? 'text-[#4f3af6]' : 'text-gray-700 hover:text-[#4f3af6]'
            }`}
          >
            Guide
          </Link>
          <Link
            to="/purchase"
            className={`text-base font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isActive('/purchase') ? 'text-[#4f3af6]' : 'text-gray-700 hover:text-[#4f3af6]'
            }`}
          >
            Purchase
          </Link>
          <Link
            to="/support"
            className={`text-base font-medium transition-colors whitespace-nowrap cursor-pointer ${
              isActive('/support') ? 'text-[#4f3af6]' : 'text-gray-700 hover:text-[#4f3af6]'
            }`}
          >
            Contact Us
          </Link>
        </div>

        <a
          href="https://seopower-co-1068490596696.us-west1.run.app"
          target="_blank"
          rel="noopener noreferrer"
          className="px-6 py-2 border-2 border-[#4f3af6] text-[#4f3af6] rounded-full font-medium hover:bg-[#4f3af6] hover:text-white transition-all whitespace-nowrap cursor-pointer"
        >
          Run SEO Report
        </a>
      </div>
    </nav>
  );
};

export default Navbar;
